import React, {ReactElement} from "react";
import {AdminPanel} from "../AdminPanel";

//https://mui.com/joy-ui/getting-started/templates/order-dashboard/

export class RightAside extends React.Component<any, any> {
    static reload: boolean = false;
    static isOpen: boolean = false;
    private touchstartX: number = 0;
    private touchstartY: number = 0;

    componentDidMount() {
        RightAside.isOpen = (
            document.querySelector('.right-aside-holder') as HTMLElement
        ).classList.contains('right-aside-open');

        document.addEventListener('touchstart', this.touchStart)
        document.addEventListener('touchend', this.touchEnd);
    }

    componentWillUnmount() {
        document.removeEventListener('touchstart', this.touchStart);
        document.removeEventListener('touchend', this.touchEnd);
    }

    render(): ReactElement {
        return (
            <>
                <div className="right-aside-holder row right-aside-close">
                    <div className="right-aside-overlay" onClick={RightAside.close}>&nbsp;</div>
                    <div className="right-aside">
                        <div id="right-aside-placeholder"></div>
                    </div>
                </div>
            </>
        );
    }

    static open(htmlElement: HTMLElement | string | React.MouseEvent, options: any = {}): void {
        if (RightAside.isOpen) {
            return;
        }
        if (typeof htmlElement === 'string') {
            htmlElement = document.querySelector(htmlElement) as HTMLElement;
        }
        if (!(htmlElement instanceof HTMLElement)) {
            htmlElement = document.querySelector(((htmlElement.target as HTMLElement)
                .closest('[data-open]') as HTMLElement).getAttribute('data-open') as string) as HTMLElement;
        }
        const holder = document.querySelector('.right-aside-holder') as HTMLElement;
        const aside = holder.querySelector('.right-aside') as HTMLElement;
        const placeholder = holder.querySelector('#right-aside-placeholder') as HTMLElement;

        aside.style.maxWidth = typeof options.maxWidth !== "undefined" ? options.maxWidth : "600px";

        RightAside.swapElements(htmlElement, placeholder);

        htmlElement.classList.remove('hidden');

        if (holder.classList.contains('right-aside-close')) {
            holder.classList.remove('right-aside-close');
        }
        if (!holder.classList.contains('right-aside-open')) {
            holder.classList.add('right-aside-open');
        }

        RightAside.isOpen = true;
    }

    static swapElements(el1: HTMLElement, el2: HTMLElement): void {
        const parent1 = el1.parentNode as HTMLElement;
        const parent2 = el2.parentNode as HTMLElement;
        const temp = document.createElement("div");

        parent1.replaceChild(temp, el1);
        parent2.replaceChild(el1, el2);
        parent1.replaceChild(el2, temp);
    }

    static close(e: any = undefined): void {
        if (typeof e === 'object') {
            e.preventDefault();
        }

        if (RightAside.reload) {
            window.location.reload();
            return;
        }

        const holder = document.querySelector('.right-aside-holder') as HTMLElement;

        if (!holder.classList.contains('right-aside-close')) {
            holder.classList.add('right-aside-close');
        }
        holder.classList.remove('right-aside-open');

        setTimeout(function () {

            const aside = holder.querySelector('.right-aside') as HTMLElement;
            const htmlElement = (aside.firstChild) as HTMLElement;
            const placeholder = document.querySelector('#right-aside-placeholder') as HTMLElement;

            RightAside.swapElements(htmlElement, placeholder);

            if (htmlElement.classList.contains('hidden')) {
                htmlElement.classList.add('hidden');
            }

            RightAside.isOpen = false;
        }, 250);
    }

    private touchStart(e: any) {
        this.touchstartX = e.changedTouches[0].screenX;
        this.touchstartY = e.changedTouches[0].screenY;
    }

    private touchEnd(e: any) {
        const touchendX = e.changedTouches[0].screenX,
            touchendY = e.changedTouches[0].screenY,
            swipeX: number = this.touchstartX - touchendX;

        if (Math.abs(this.touchstartX - touchendX) < Math.abs(this.touchstartY - touchendY)) {
            return; // vertical swipe
        }

        if (touchendX > this.touchstartX && AdminPanel.swipeYThreshold < Math.abs(swipeX)) {
            let adminPage = document.querySelector('.right-aside-holder') as HTMLElement;
            if (adminPage.classList.contains('right-aside-open')) {
                RightAside.close();
            }
        }
    }
}
